import { useCallback } from "react";

import { useProductOptionFormModelContext } from "../../../../context";

export const useIsNotDiscountTarget = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();

	const onSetIsNotDiscountTarget = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "isNotDiscountTarget",
					value: { isEdited: true, value: input },
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isNotDiscountTarget: viewModel.isNotDiscountTarget,
		onSetIsNotDiscountTarget,
	};
};
